/** Check this link before editing https://material.angular.io/components/dialog/api */

import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { IConfirmDeleteDialogData } from "libraries/interfaces/IConfirmDeleteDialogData";
import { Subscription } from "rxjs";
import { filter } from "rxjs/operators";
import { ISectorAirDeleteDialogResponse, SectorAirDeleteDialogService } from "./sector-air-delete-dialog.service";
import { Yii } from "../../../../../../../interfaces/Yii";
import { NotificationType } from 'libraries/interfaces/INotification';

@Component({
    selector: 'sector-air-delete-dialog',
    template: `
        <card [@.disabled]="true" mat-dialog-content>
            <div class="card-header-content">
                <h1>{{ data.title }}</h1>
                <div class="btn-container">
                    <btn type="actionLink" 
                         [label]="data.cancel" 
                         [disableIf]="isLoading || needRefresh"
                         (onClick)="close()"></btn>
                    <btn class="e2e-btn-update" type="actionDo" 
                         [label]="data.accept" 
                         [disableIf]="isLoading || needRefresh"
                         (onClick)="delete()"></btn>
                </div>
            </div>

            <div class="card-body-content">
                <notification
                        class="notifications"
                        *ngIf="!isLoading && data.hasServices"
                        [type]="notificationType.Warning"
                        [showCloseButton]="false">
                    {{ deleteSegmentServicesWarning }}
                </notification>
                <notification
                        class="notifications"
                        *ngIf="!isLoading && (isError || needRefresh)"
                        [type]="notificationType.Error"
                        [showCloseButton]="false">{{ deleteSegmentError }}
                </notification>
                <p *ngIf="!isLoading">{{ data.question }}</p>
                <div *ngIf="!isLoading" class="card-body-content-sectors">
                    <sector
                        *ngFor="let sectorItem of data.sectors"
                        class="card-body-content-sector"
                        [sectorItem]="sectorItem"
                        [key]="false">
                    </sector>
                </div>
                <loader *ngIf="isLoading" [message]="data.loaderMessage"></loader>
            </div>
        </card>
    `,
    styles: [`
        .card-body-content-sectors {
            align-items: center;
            display: flex;
            flex-direction: column;
            justify-content: center;
            padding-top: 2rem;
        }
        
        .notifications {
            margin-bottom: .5rem;
            margin-top: .5rem;
        }

        .card-body-content-sector {
            padding: .5rem;
        }

        .card-body-content {
            padding: .75rem .75rem 0 .75rem;
        }

        .card-header-content {
            display: flex;
            justify-content: space-between;
        }

        .btn-container {
            display: flex;
        }`]
})
export class SectorAirDeleteDialogComponent implements OnInit, OnDestroy {
    public isLoading: boolean = false;
    public isError: boolean = false;
    public needRefresh: boolean = false;
    public deleteSegmentPermission: boolean = false;
    public deleteSegmentError: string = Yii.t('wui-sasha-js', 'Erreur lors de la suppression');
    public deleteSegmentServicesWarning: string = Yii.t('wui-sasha-js', 'Ce dossier continent des services annexes');
    public notificationType: typeof NotificationType = NotificationType;

    private readonly subscription: Subscription = new Subscription();
    private timeoutRefresh: any;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: IConfirmDeleteDialogData,
        private readonly matDialogRef: MatDialogRef<SectorAirDeleteDialogComponent>,
        private sectorAirDeleteDialogService: SectorAirDeleteDialogService
    ) {
    }

    public ngOnInit(): void {
        // force refresh booking if not key in sector
        if (!this.isSectorKey()) {
            this.matDialogRef.disableClose = true;
            this.needRefresh = true;
            this.deleteSegmentError = Yii.t('wui-sasha-js', 'Votre dossier n’est pas à jour, nous allons procéder à son rafraichissement.');
            // use timeout to refresh and show message
            this.timeoutRefresh = setTimeout((): void => {
                this.sectorAirDeleteDialogService.refreshBooking();
                this.close();
            }, 4000);
        }

        if(this.data.hasServices){

        }
        this.subscription
            .add(
                this.matDialogRef.keydownEvents()
                    .pipe(
                        filter((event: KeyboardEvent): boolean => event.key === "Enter"),
                    )
                    .subscribe((): void => {
                        if (!(this.isLoading || this.needRefresh)) {
                            this.delete();
                        }
                    })
            )
            .add(
                this.sectorAirDeleteDialogService.sectorAirDeleteResponseObs
                    .subscribe((res: ISectorAirDeleteDialogResponse): void => {
                        this.isLoading = false;
                        if (res && res.isDone) {
                            this.close();
                        } else {
                            this.isError = true;
                            this.deleteSegmentError = res?.error?.message ?
                                res.error.message :
                                Yii.t('wui-sasha-js', 'Erreur lors de la suppression');
                        }
                        this.matDialogRef.disableClose = false;
                    })
            );
    }

    public ngOnDestroy(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
        if (this.timeoutRefresh) {
            clearTimeout(this.timeoutRefresh);
        }

    }

    public close(): void {
        this.matDialogRef.close();
    }

    public delete(): void {
        this.matDialogRef.disableClose = true;
        this.isLoading = true;
        this.sectorAirDeleteDialogService.delete(this.data.deleteSectorsRequest);
    }

    private isSectorKey(): boolean {
        if (this.data && this.data.deleteSectorsRequest && this.data.deleteSectorsRequest.booking && this.data.deleteSectorsRequest.booking.segmentArray) {
            return !this.data.deleteSectorsRequest.booking.segmentArray
                .some((segmentArray: { xId: string, key: string }): boolean => segmentArray.key === undefined);
        }
        return false;
    }

}
